import ChatAreaMessage from 'components/ChatAreaMessage';
import React, { useEffect, useRef } from 'react';

export default function ChatArea({
    messages,
    setSticky,
    isThinking
}) {

    const chatRef = useRef(null);

    useEffect(() => {
        const el = chatRef.current;
        if (!el) return;

        const onScroll = () => {
            if (el.scrollTop > 10) {
                setSticky(true);
            } else {
                setSticky(false);
            }
        };
        const lastMessageEl = el.querySelector('#chat-area > div > div:last-child');

        const top = lastMessageEl?.offsetTop || 0;
        el.scrollTo({
            top,
            behavior: 'smooth'
        });

        el.addEventListener('scroll', onScroll);

        return () => el.removeEventListener('scroll', onScroll)
    }, [messages, setSticky]);

    const filteredMessages = messages?.filter(m => m.content && m.content.trim() !== '' && m.role !== 'system');

    return (
        <div
            className='relative h-[100svh] overflow-y-auto scroll-smooth'
            ref={chatRef}
            style={{
                scrollbarWidth: 'thin',
                scrollbarColor: 'rgba(0,0,0,0.2) transparent'
            }}
        >
            <div
                className="flex flex-col mx-auto px-4 md:px-6 pt-20 pb-[250px] md:pb-[300px] box-border"
                id="chat-area"
            >
                <div className='w-full max-w-3xl mx-auto'>
                    {filteredMessages?.length === 0 && !isThinking && (
                        <div className='flex flex-col items-center justify-center min-h-[50vh] text-center'>
                            <div className='text-4xl md:text-5xl font-medium text-black/80 mb-4'>
                                Come posso aiutarti?
                            </div>
                            <p className='text-black/50 text-lg'>
                                Inizia una conversazione scrivendo un messaggio
                            </p>
                        </div>
                    )}

                    {filteredMessages?.map((message, index) => (
                        <ChatAreaMessage
                            message={message}
                            key={message._id}
                            isLastMessage={index === filteredMessages.length - 1}
                        />
                    ))}

                    {isThinking && (
                        <div className='w-full flex py-6 justify-start items-start'>
                            <div className='flex items-center gap-3 text-black/70'>
                                <div className='flex gap-1'>
                                    <span className='w-2 h-2 bg-black/40 rounded-full animate-bounce' style={{animationDelay: '0ms'}}></span>
                                    <span className='w-2 h-2 bg-black/40 rounded-full animate-bounce' style={{animationDelay: '150ms'}}></span>
                                    <span className='w-2 h-2 bg-black/40 rounded-full animate-bounce' style={{animationDelay: '300ms'}}></span>
                                </div>
                                <span className='text-sm'>Sto pensando...</span>
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </div>
    )
}
